import { useCallback, useEffect, useState } from 'react';
import { useToast, Modal } from './shared';

const EVENT = { login: ['✓ دخول', 'badge-green'], failed: ['✗ محاولة فاشلة', 'badge-red'], logout: ['↩ خروج', 'badge-gray'] };
const REASON = { wrong_password: 'باسورد غلط', unknown_user: 'يوزر مش موجود' };
const DEV_ICON = { Mobile: '📱', Tablet: '📱', Desktop: '💻' };
const flag = cc => (cc && /^[A-Z]{2}$/.test(cc) ? String.fromCodePoint(...[...cc].map(c => 0x1f1a5 + c.charCodeAt(0))) : '');
// stored as UTC "YYYY-MM-DD HH:MM:SS" → Cairo local time
const when = s => {
  const d = new Date(String(s).replace(' ', 'T') + 'Z');
  return isNaN(d) ? s : d.toLocaleString('en-GB', { timeZone: 'Africa/Cairo', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
};
const ago = s => {
  const m = (Date.now() - new Date(String(s).replace(' ', 'T') + 'Z')) / 60000;
  if (m < 1) return 'دلوقتي';
  if (m < 60) return `من ${Math.floor(m)} دقيقة`;
  if (m < 1440) return `من ${Math.floor(m / 60)} ساعة`;
  return `من ${Math.floor(m / 1440)} يوم`;
};

/** Login history table. userId fixes the filter to one account (used inside the per-user modal). */
export default function LoginLog({ userId, compact }) {
  const [users, setUsers] = useState([]);
  const [f, setF] = useState({ user_id: userId || '', event: '', from: '', to: '' });
  const [data, setData] = useState(null);
  const toast = useToast();

  useEffect(() => { if (!userId) fetch('/api/users/all').then(r => r.json()).then(setUsers).catch(() => {}); }, [userId]);
  const load = useCallback(() => {
    const q = new URLSearchParams(Object.fromEntries(Object.entries({ ...f, limit: compact ? 100 : 300 }).filter(([, v]) => v)));
    fetch(`/api/users/login-log?${q}`).then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.error); setData(j); })
      .catch(e => toast(e.message, 'error'));
  }, [f, compact, toast]);
  useEffect(() => { load(); }, [load]);
  const set = k => e => setF(x => ({ ...x, [k]: e.target.value }));

  const st = data && data.stats;
  return (
    <div dir="rtl">
      <div className="flex gap-8 mb-16" style={{ flexWrap: 'wrap', alignItems: 'center' }}>
        {!userId && <select className="select" style={{ maxWidth: 230 }} value={f.user_id} onChange={set('user_id')}>
          <option value="">كل المستخدمين</option>
          {users.map(u => <option key={u.id} value={u.id}>{u.username}{u.client_name ? ` — ${u.client_name}` : ` (${u.role})`}</option>)}
        </select>}
        <select className="select" style={{ maxWidth: 160 }} value={f.event} onChange={set('event')}>
          <option value="">كل الأحداث</option>
          {Object.entries(EVENT).map(([k, [l]]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <label className="text-xs text-dim">من</label><input type="date" className="input" style={{ width: 150 }} value={f.from} onChange={set('from')} />
        <label className="text-xs text-dim">لـ</label><input type="date" className="input" style={{ width: 150 }} value={f.to} onChange={set('to')} />
        <button className="btn btn-ghost btn-sm" onClick={load}>↻</button>
      </div>

      {st && <div className="flex gap-8 mb-16" style={{ flexWrap: 'wrap' }}>
        <span className="badge badge-green">{st.logins || 0} دخول</span>
        <span className={`badge ${st.failed ? 'badge-red' : 'badge-gray'}`}>{st.failed || 0} محاولة فاشلة</span>
        <span className="badge badge-blue">{st.ips || 0} IP مختلف</span>
        {st.last_login && <span className="text-xs text-muted" style={{ alignSelf: 'center' }}>آخر دخول: <bdi dir="ltr">{when(st.last_login)}</bdi> ({ago(st.last_login)})</span>}
      </div>}

      <div className="table-wrap">
        <table>
          <thead><tr><th>الوقت</th>{!userId && <th>المستخدم</th>}<th>الحدث</th><th>IP</th><th>المكان</th><th>الجهاز</th></tr></thead>
          <tbody>
            {!data ? <tr><td colSpan={6}><div className="empty">...</div></td></tr>
              : data.rows.length === 0 ? <tr><td colSpan={6}><div className="empty">مفيش سجل لسه</div></td></tr>
              : data.rows.map(r => {
                const [el, ec] = EVENT[r.event] || [r.event, 'badge-gray'];
                const place = [r.city, r.region !== r.city ? r.region : null].filter(Boolean).join('، ');
                return (
                  <tr key={r.id}>
                    <td className="text-sm" style={{ whiteSpace: 'nowrap' }}><bdi dir="ltr">{when(r.created_at)}</bdi><div className="text-xs text-dim">{ago(r.created_at)}</div></td>
                    {!userId && <td className="text-sm"><span className="mono fw-500">{r.username || '—'}</span>
                      <div className="text-xs text-dim">{r.client_name || r.role || ''}</div></td>}
                    <td><span className={`badge ${ec}`}>{el}</span>{r.reason && <div className="text-xs text-dim mt-4">{REASON[r.reason] || r.reason}</div>}</td>
                    <td className="mono text-sm" dir="ltr" style={{ textAlign: 'right' }}>{r.ip || '—'}</td>
                    <td className="text-sm">
                      {place || r.country ? <>{flag(r.country)} {place}{place && r.country ? ' · ' : ''}{r.country}</> : <span className="text-dim">—</span>}
                      {r.loc && <a className="text-xs" style={{ marginInlineStart: 6 }} href={`https://www.google.com/maps?q=${r.loc}`} target="_blank" rel="noreferrer">🗺️</a>}
                      {r.isp && <div className="text-xs text-dim" dir="ltr" style={{ textAlign: 'right' }}>{r.isp}</div>}
                    </td>
                    <td className="text-sm" title={r.user_agent}>{DEV_ICON[r.device] || ''} {r.browser}<div className="text-xs text-dim">{r.os}</div></td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className="text-xs text-dim mt-8">المكان تقريبي من الـIP (مدينة/مزود الخدمة)، مش GPS.</div>
    </div>
  );
}

export function LoginLogModal({ user, onClose }) {
  return (
    <Modal width={980} title={`سجل الدخول — ${user.username}`} onClose={onClose}>
      <LoginLog userId={user.id} compact />
    </Modal>
  );
}
